'use client';

import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { type Region } from '@/services/rental-api-client';
import { HorizontalLocationSelectList } from './HorizontalLocationSelectList';
import { LocationField } from './LocationField';
import { LocationSelectProvider, type LocationSelectProviderProps } from './LocationSelectContext';
export type fieldOptions = {
  name: string;
  label: string;
  placeholder?: string;
  value?: InputHTMLAttributes<HTMLInputElement>['value'];
  onChange?: (e?: ChangeEvent<HTMLInputElement>) => void;
};
export type LocationSelectProps = {
  className?: string;
  regions: Region[];
  variant?: 'horizontal' | 'vertical';
  fieldOptions: {
    pickUp: fieldOptions;
    dropOff: fieldOptions;
  };
  header?: ReactNode;
  footer?: ReactNode;
  onRegionChange?: LocationSelectProviderProps['onRegionChange'];
};
export function LocationSelect(t0) {
  const $ = _c(27);
  const {
    className,
    regions,
    fieldOptions: t1,
    header,
    footer,
    variant,
    onRegionChange
  } = t0;
  const {
    pickUp: pickUpField,
    dropOff: dropOffField
  } = t1;
  const t2 = pickUpField.value as string;
  const t3 = dropOffField.value as string;
  let t4;
  if ($[0] !== className) {
    t4 = cn("flex gap-6 group max-h-full flex-1", className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== pickUpField) {
    t5 = <LocationField field="pickUp" fieldOptions={pickUpField} />;
    $[2] = pickUpField;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== dropOffField) {
    t6 = <LocationField field="dropOff" fieldOptions={dropOffField} />;
    $[4] = dropOffField;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <div className="flex flex-col gap-8">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== footer || $[10] !== header || $[11] !== t7) {
    t8 = <div className="flex flex-col gap-2 w-full lg:w-81.75 lg:pb-6 flex-none peer justify-between">{header}{t7}{footer}</div>;
    $[9] = footer;
    $[10] = header;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== dropOffField || $[14] !== pickUpField) {
    t9 = <HorizontalLocationSelectList pickUpField={pickUpField} dropOffField={dropOffField} />;
    $[13] = dropOffField;
    $[14] = pickUpField;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t4 || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className={t4}>{t8}{t9}</div>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onRegionChange || $[21] !== regions || $[22] !== t10 || $[23] !== t2 || $[24] !== t3 || $[25] !== variant) {
    t11 = <LocationSelectProvider variant={variant} regions={regions} pickUpLocationCode={t2} dropOffLocationCode={t3} onRegionChange={onRegionChange}>{t10}</LocationSelectProvider>;
    $[20] = onRegionChange;
    $[21] = regions;
    $[22] = t10;
    $[23] = t2;
    $[24] = t3;
    $[25] = variant;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}